var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame720(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 116,
    viewBox: "0 0 116 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_2123_102072)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 42C28 25.4315 41.4315 12 58 12C74.5685 12 88 25.4315 88 42C88 58.5685 74.5685 72 58 72C41.4315 72 28 58.5685 28 42Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.4775 56.6162C58.1851 56.6162 58.887 56.6268 59.4551 56.6475C59.7394 56.6578 59.9815 56.6704 60.1699 56.6846C60.3367 56.6971 60.421 56.7084 60.4463 56.7119C60.5228 56.7303 60.5906 56.7519 60.6494 56.7734C60.5772 56.9447 60.4411 57.1257 60.2256 57.2754L60.1914 57.2988L60.1592 57.3242C59.55 57.7991 58.8364 58.0993 58.0908 58.209C57.7707 58.2497 57.4621 58.2604 57.1631 58.2402L56.8633 58.209C56.1169 58.099 55.4052 57.7983 54.7998 57.3242L54.7646 57.2969L54.7275 57.2715L54.6133 57.1836C54.4632 57.0555 54.363 56.9115 54.3047 56.7734C54.3634 56.7519 54.4313 56.7303 54.5078 56.7119C54.5319 56.7086 54.6162 56.6973 54.7852 56.6846C54.9735 56.6704 55.2156 56.6578 55.5 56.6475C56.0681 56.6268 56.7699 56.6162 57.4775 56.6162ZM57.4277 28.75H57.5732C60.4257 28.75 63.3321 30.0743 65.1016 32.2207L65.2734 32.4355C66.3819 33.863 66.8994 35.2439 66.8994 37.6016V38.2939C66.8994 39.4511 67.0528 40.4548 67.4189 41.3975C67.7837 42.3365 68.3263 43.1286 68.9863 43.8994L68.9932 43.9072L69 43.916C69.5596 44.5515 69.8125 45.4385 69.8125 46.6787C69.8125 47.7491 69.4683 48.7357 68.7939 49.5391C67.8839 50.505 66.6229 51.1461 65.334 51.3164L65.0742 51.3438L65.0703 51.3447C62.5259 51.5616 60.0232 51.7402 57.501 51.7402C54.9523 51.7402 52.4574 51.632 49.9736 51.3486L49.9502 51.3457L49.9268 51.3438L49.667 51.3164C48.378 51.1461 47.1187 50.5063 46.2109 49.543C45.5337 48.7381 45.1875 47.7497 45.1875 46.6787C45.1875 45.4399 45.4415 44.5515 46.001 43.915L46 43.9141C46.6876 43.1351 47.2364 42.3373 47.5986 41.3906C47.961 40.4436 48.1025 39.4398 48.1025 38.2939V37.6016C48.1026 35.2002 48.6743 33.7489 49.8486 32.2812C51.6393 30.0916 54.551 28.7501 57.4277 28.75Z",
    stroke: "#9A4FE0",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 28.5,
    r: 4.5,
    fill: "#9A4FE0",
    stroke: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_2123_102072",
    x: 0,
    y: 0,
    width: 116,
    height: 116,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 4,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_dropShadow_2123_102072"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 16
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.568627 0 0 0 0 0.619608 0 0 0 0 0.670588 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2123_102072"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.568627 0 0 0 0 0.619608 0 0 0 0 0.670588 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2123_102072",
    result: "effect2_dropShadow_2123_102072"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2123_102072",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame720);
export default __webpack_public_path__ + "static/media/Frame720.e021e0429476b91f7d7b7c6e3eb4bde2.svg";
export { ForwardRef as ReactComponent };